// src/components/Authentication/PasswordRecovery.js

import React, { useState, useContext } from 'react';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import CustomModal from '../Common/CustomModal';
import { DataContext } from '../../DataContext'; // Import DataContext
import { useColorSettings } from '../Common/ColorSettingsContext';
import { useLanguageSettings } from '../Common/LanguageSettingsContext';
import './PasswordRecovery.css';
import { useTranslation } from 'react-i18next';
import Spinner from '../Common/Spinner';

const PasswordRecovery = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // Access appSettings from DataContext
  const { appSettings, appSettingsLoading } = useContext(DataContext);

  // Access language settings from LanguageSettingsContext
  const { loading: languageLoading } = useLanguageSettings();

  // Access loading state from ColorSettingsContext
  const { loading: colorLoading } = useColorSettings();

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      await auth.sendPasswordResetEmail(email);
      setMessage(t('passwordRecovery.successMessage'));
      setShowModal(true);
    } catch (error) {
      setMessage(t('passwordRecovery.error', { error: error.message }));
      setShowModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/');
  };

  const goToLogin = () => {
    navigate('/');
  };

  // Handle loading state by combining loading states
  if (colorLoading || languageLoading || appSettingsLoading) {
    return (
      <div className="password-recovery-background">
        <div className="password-recovery-container">
          <Spinner />
        </div>
      </div>
    );
  }

  return (
    <div className="password-recovery-background">
      <div className="password-recovery-container">
        <div className="password-recovery-logo">
          <img
            src={
              appSettings?.logoUrl ||
              'https://firebasestorage.googleapis.com/v0/b/tabitapp-6b25a.appspot.com/o/TABITA-LOGO%20small.png?alt=media&token=152bfee7-fc9e-48de-b957-efcca798f0ed'
            }
            alt={t('passwordRecovery.logoAlt')}
          />
        </div>
        <h2>{t('passwordRecovery.title')}</h2>
        <form onSubmit={handleSubmit} className="password-recovery-form">
          <div className="password-recovery-input-group">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t('passwordRecovery.emailPlaceholder')}
              required
              aria-label={t('passwordRecovery.emailLabel')}
            />
          </div>
          <button type="submit" className="password-recovery-submit-button">
            {t('passwordRecovery.resetButton')}
          </button>
          <br />
          <br />
          <h6 onClick={goToLogin} className="password-recovery-forgot">
            {t('passwordRecovery.backToLogin')}
          </h6>
        </form>
      </div>
      <CustomModal
        show={showModal}
        onClose={handleCloseModal}
        title={t('passwordRecovery.modalTitle')}
      >
        <p className='password-recovery-message'>{message}</p>
      </CustomModal>
    </div>
  );
};

export default PasswordRecovery;
